
import { useEffect, useState } from "react";
import { E_immatriculation } from "../../../../constants/constant";
import axios from "axios";
import { RiArrowGoBackFill} from "react-icons/ri";

import { MdOpenInNew } from "react-icons/md";
import Label from "../../../../components/title/label";
import Input from "../../../../components/input/Input";
import Checkbox from "../../../../components/button/Checkbox";
import Table from "../../../../components/table/Table";
import { Link } from "react-router-dom";
import { Navbar } from "../../../../components/navbar/Navbar";
import BackButton from "../../../../components/button/BackButton";

function DirigeantContribuable() {
    const [add , setAdd] = useState(false);
    const [DataSelectedDirigeant, setDataSelectedDirigeant] = useState([]);
  
    const [Dirigant , setDirigeant ] = useState([]); 
  
    const [TableDirigeant , setTableDirigeant] = useState([]);
    
    const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
   
    const [ContribuableData] = useState(
    JSON.parse(selectedData)
  );
  
    const filterId = ContribuableData.id 
  
  
  
  
    useEffect(() => {
      // Récupérer les données depuis le backend
      axios.get(`${E_immatriculation}/dirigeant/modelTemp`)
        .then((response) => setTableDirigeant(response.data))
        .catch((error) => {console.error(error)});
    }, []);
    useEffect(() => {
      const filteredData = TableDirigeant.filter((item) =>
        item.id_contribuable?.toString().includes(filterId)
      );
      setDirigeant(filteredData);
    }, [TableDirigeant , filterId]);
    
    console.log('dirigeant get :', TableDirigeant)
  
  
    const [selectedRowIndexDirigeant, setSelectedRowIndexDirigeant] = useState(null);
  
  
    const [isStorageUpdatedDirigeant, setIsStorageUpdatedDirigeant] = useState(false);
  
    useEffect(() => {
       console.log(DataSelectedDirigeant)
       setIsStorageUpdatedDirigeant(false);
    }, [DataSelectedDirigeant, isStorageUpdatedDirigeant]);
    
  
    const handleSelectedDataTableDirigeant = (rowIndex) => {
      // Check if the clicked row is already selected
      const isRowSelected = rowIndex === selectedRowIndexDirigeant;
    
      // If the row is selected, unselect it
      if (isRowSelected) {
        setSelectedRowIndexDirigeant(null);
        setDataSelectedDirigeant([]);
      } else {
        // If the row is not selected, select it
        setSelectedRowIndexDirigeant(rowIndex);
        const selectedRowDataDirigeant = TableDirigeant[rowIndex];
        setDataSelectedDirigeant(selectedRowDataDirigeant);
      }
    
      console.log("selected :", DataSelectedDirigeant);
    };
  
    // Table dirigeant
     const HeaderDirigent = ["Nom" , "fonction" , "cin" , "passport" , "RF" , "email" , "telephone" ]
     const datadirigeant = Dirigant ? Dirigant.map((item)=>[item.nom ,item.fonction , item.cin , item.passport , item.rf , item.email , item.telephone 
 ] ): [["Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" ,"" , ""]];
   


    const contentNavbar = (
      <nav className="flex items-center justify-between">
       <div className="text-white">
          Dirigieant
       </div>
        <BackButton to="/SituationGeographiqueIm"></BackButton>
      </nav>
    );

    return (
    <div className="w-full bg-[#212122] h-screen">
      <Navbar content={contentNavbar} />
      <main className=""> <div className="flex flex-col ">
  
      <div className="  p-4">
      { add === true && ( 
            <div>
  
  
    <>
    <div className="flex justify-between mt-6">
      <Label text="Nom "></Label>
      <Input type="text"
      value={DataSelectedDirigeant?DataSelectedDirigeant.nom : ""}
      onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , nom : e.target.value})}
      ></Input>
    </div>
    <div className="flex justify-between mt-6">
      <Label text="Fonction"></Label>
      <Input type="text"
      
      value={DataSelectedDirigeant?DataSelectedDirigeant.fonction : ""}
      onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , fonction : e.target.value})}
      ></Input>
    </div>
    <div className="flex justify-between mt-6">
              <Label text="Etranger " />
        <div className="flex justify-between w-[200px]">
      <Checkbox label="Oui" onChange={()=>setDataSelectedDirigeant({ ...DataSelectedDirigeant, resident: true})} checked={DataSelectedDirigeant.resident === true}></Checkbox>
      <Checkbox label="Non" onChange={()=>setDataSelectedDirigeant({...DataSelectedDirigeant , resident: false})} checked={DataSelectedDirigeant.resident === false}></Checkbox>
      </div>
      </div>
      { DataSelectedDirigeant.resident === false && (
        <>
        <div className="flex justify-between mt-6">
  <Label text="Numero CIN"></Label>
  <Input type="text"
  value={DataSelectedDirigeant? DataSelectedDirigeant.cin : ""}
  onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , cin : e.target.value})}
  ></Input>
        </div>
        </>
      )
  
      }
      { DataSelectedDirigeant.resident === true && (
        <>
        <div className="flex justify-between mt-6">
  <Label text="Numéro Passeport ou Carte Résident"></Label>
  <Input type="text"
  value={DataSelectedDirigeant? DataSelectedDirigeant.passport : ""}
  onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , passport : e.target.value})}
  ></Input>
        </div>
        </>
      )
  
      }
    <div className="flex justify-between mt-6">
      <Label text="Adresse  "></Label>
      <Input type="text"
      value={DataSelectedDirigeant? DataSelectedDirigeant.adresse : ""}
      onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , adresse : e.target.value})}
      ></Input>
    </div>
    <div className="flex justify-between mt-6">
              <Label text="Autre activité " />
        <div className="flex justify-between w-[300px]">
      <Checkbox label="Avec RF" onChange={(checked )=> setDataSelectedDirigeant({...DataSelectedDirigeant , avec_rf : checked})} checked={DataSelectedDirigeant.avec_rf} ></Checkbox>
      <Checkbox label="Salarié" onChange={(checked)=>setDataSelectedDirigeant({...DataSelectedDirigeant , salarie: checked})} checked={DataSelectedDirigeant.salarie}></Checkbox>
      <Checkbox label="Aucune " onChange={(checked)=> setDataSelectedDirigeant({...DataSelectedDirigeant , aucune: checked})} checked={DataSelectedDirigeant.aucune}></Checkbox>
      </div>
      </div>
      { DataSelectedDirigeant.avec_rf === true && (
        <> 
      <div className="flex justify-between mt-6">
        <Label text="RF"></Label>
        <Input type="text"
        value={DataSelectedDirigeant? DataSelectedDirigeant.rf : ""}
        onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , rf : e.target.value})}
        ></Input>
      </div>  
        </>
      )
  
      }
    <div className="flex justify-between mt-6">
      <Label text="Email "></Label>
      <Input type="text"
      value={DataSelectedDirigeant? DataSelectedDirigeant.email : ""}
      onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , email : e.target.value})}
      ></Input>
    </div>
    <div className="flex justify-between mt-6">
      <Label text="Telephone "></Label>
      <Input type="text"
      
      value={DataSelectedDirigeant ? DataSelectedDirigeant.telephone : ""}
      onChange={(e)=> setDataSelectedDirigeant({...DataSelectedDirigeant , telephone : e.target.value })}
      
      ></Input>
    </div>
     
    
    </>
  
    
          
          <div className="flex justify-center mt-6">
          <button onClick={()=> setAdd(false)}  className="border-[2px] ml-4 p-2 border-white rounded hover:bg-black/70 hover:text-white text-white flex flex-row"><RiArrowGoBackFill  className="text-2xl text-white mr-2"/> Annuler</button>
          </div>
            </div>
           )}
          
  { add === false  && (
  
  <div className="flex flex-col">
    <div  className="flex justify-center">
     
     <div className="w-[1000px] p-4 mt-6  flex justify-center">
   <Table
   headers={HeaderDirigent}
   data={datadirigeant}
   onClick={handleSelectedDataTableDirigeant}
   selectedRowIndex={selectedRowIndexDirigeant}
   ></Table>
   </div>
 
   </div>
   <div >
 <div className="flex justify-center mt-6">
   <div >
             <button onClick={()=> setAdd(true)} className="border-[2px] p-2 border-white rounded hover:bg-black/70 hover:text-white "><MdOpenInNew className="text-white"></MdOpenInNew></button>
   </div>

   </div>
   <div className="flex justify-between  mt-6">
   <Link to={`/SituationGeographiqueIm`}  className="border-[2px]  mt-6 mb-6 w-40 p-2 border-white text-white rounded hover:bg-black/70 hover:text-white flex flex-row"><RiArrowGoBackFill  className="text-2xl mr-2"/> Retour</Link>
   
   </div>
 </div>
  </div>
  )} 
      </div>
    
    </div></main>
    </div>
    )
  }
export default DirigeantContribuable